import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserService } from '../service/userService';
import { LoginComponent } from './login.component';
//import { GrowlModule } from 'primeng/primeng';
 import { ToastModule } from 'primeng/toast';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    // GrowlModule,
    ToastModule
  ],
  exports: [
    LoginComponent
  ],
  declarations: [
    LoginComponent
  ],
  providers: [UserService]
})
export class LoginModule { }
